(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4823],{

/***/ 7573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);



var server = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
  baseURL: "https://mu7.ejjadh.info"
});
server.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref = (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
    var _error$response;

    var config;
    return _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = error.config;

            if (config) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.reject(error));

          case 3:
            config.__retryCount = config.__retryCount || 0;

            if (!(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 429 && config.__retryCount < 3)) {
              _context.next = 10;
              break;
            }

            config.__retryCount++;
            console.log("429 received. Retry ".concat(config.__retryCount, "/3 for ").concat(config.url));
            _context.next = 9;
            return new Promise(function (r) {
              return setTimeout(r, 15000);
            });

          case 9:
            return _context.abrupt("return", server(config));

          case 10:
            return _context.abrupt("return", Promise.reject(error));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["Z"] = (server);

/***/ }),

/***/ 2094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PageHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _PageHeader_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8317);
/* harmony import */ var _PageHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PageHeader_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _NavigationBar_NavigationBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4208);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);




function PageHeader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: (_PageHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["page-header"]),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_PageHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().navbar),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavigationBar_NavigationBar__WEBPACK_IMPORTED_MODULE_1__["default"], {
        HomePage: true
      })
    })
  });
}

/***/ }),

/***/ 8317:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-header":"PageHeader_page-header__BK1lb","navbar":"PageHeader_navbar__Nzf3Z"};

/***/ })

}]);